<template>
  <section v-loading="loading" class="elsa-section">
    <h3 class="section-title">
      <i v-if="icon" :class="icon"  />
      {{ title }}
      <el-tooltip
        v-if="information"
        :content="information"
      >
        <i class="el-icon-info"/>
      </el-tooltip>
    </h3>
    <div class="section-body">
      <slot name="body"></slot>
    </div>
    <div v-if="availableFooter" class="section-footer">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: null
      },
      information: {
        type: String,
        default: null
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      availableFooter() {
        return !!this.$slots.footer
      }
    },
  }
</script>

<style lang="scss" scoped>
  .elsa-section {
    background: white;
    border-radius: 8px;
    padding: 32px 32px 64px 32px;
    h3 {
      text-transform: uppercase;
      display: flex;
      font-weight: bold;
      margin: 0;
    }
    .section-body {
      margin-top: 40px;
    }
    .section-footer {
      margin-top: 48px;
    }
    .el-tooltip.el-icon-info {
      margin-top: 5px;
      margin-left: 3px;
      color: #546873 !important;
      font-size: 14px !important;
    }
  }

  .spacer {
    margin-top: 32px;
  }
  @media only screen and (max-width: 768px) {
    .elsa-section {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

</style>
